import "../../../styles/CounterField.scss";

import Icon, {iconColor, iconTypes} from "./Icon.jsx"; 

import PropTypes from "prop-types";
import React from "react";

export default class CounterField extends React.Component {
    constructor(props){
        super(props);

        this.state = {
            focused: false,
            value: this.props.value || 0,
            recivedValue: this.props.value || 0,
            timeout: null,
        };

        this.onChange = this.onChange.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
        this.onSetValue = this.onSetValue.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.getClassName = this.getClassName.bind(this);
        this.clearTimeout = this.clearTimeout.bind(this);
        this.resetTimeout = this.resetTimeout.bind(this);

        this.onDoEdit = this.onDoEdit.bind(this);
        this.onClickAdd = this.onClickAdd.bind(this);
        this.onClickDecrease = this.onClickDecrease.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            value: nextProps.value,
            recivedValue: nextProps.value,
        });

        // if( nextProps.value!==this.state.recivedValue ){
        //     this.setState({
        //         value: nextProps.value,
        //         recivedValue: nextProps.value,
        //     });
        // }
    }

    onChange(event) {
        const newValStr = event.target.value.replace(/\D/,"");

        if (newValStr === "")
        {
            this.setState({
                value: "",
            });
            return;
        }

        const parsedValue = parseInt(newValStr);

        this.onSetValue(parsedValue>=1?parsedValue:0);
    }
    onFocus() {
        this.setState({ focused: true });
    }
    onBlur() {
        this.setState({ focused: false });
    }
    onDoEdit(value) {
        this.resetTimeout( () =>  {
            this.props.onEdit({
                value: value,
                salesLineId: this.props.salesLineId,
            });
        });
    }
    onSetValue(newValue) {
        const currentValue = this.state.value;
        const setValue = Math.max(this.props.minValue, newValue);
        if( this.props.activeOrder && this.props.activeOrder.bagSupplier!=null && this.props.product && this.props.product.returnTobaccoNotAllowedAnyLonger===true){
            this.props.onEdit({
                value: 0,
                salesLineId: null,
            });
            return;
        }
        if(setValue !== currentValue) {
            this.setState({
                value: setValue,
            });
        }
        this.onDoEdit(setValue);
    }
    onKeyUp(target) {
        if(target.key === "Enter") {
            //user actively pushed send
            this.onBlur();
        }
    }
    getClassName() {
        const {
            isValid
        } = this.props;

        let className = "input-text";
        if(!this.state.focused){
            if(isValid===false){
                className += " error";
            }else if(isValid===true){
                className += " is-valid";
            }
        }
        return className;
    }

    onClickAdd(event) {
        event.stopPropagation();
        event.preventDefault();
        
        this.onSetValue( (this.state.value==null || isNaN(this.state.value))?1:this.state.value+1 );

    }
    onClickDecrease(event) {
        event.stopPropagation();
        event.preventDefault();


        this.onSetValue( Math.max(this.props.minValue, this.state.value-1) );

    }
    clearTimeout() {
        if( this.state.timeout ) {
            clearTimeout(this.state.timeout);
            this.setState({
                timeout: null
            });
        }
    }
    resetTimeout(func) {
        if( this.state.timeout ) {
            clearTimeout(this.state.timeout);
        }
        this.setState({
            timeout: setTimeout( func, 500 )
        });
    }

    render() {
        const {
            className,
            disabled,
            isValid,
            spellcheck,
            placeholder,
            tabIndex,
            maxLength,
            border,
            invisibleBackground,
            alwaysShowInputField,
            small,
            notActive,
            notActiveText,
            changed,
        } = this.props;

        const expanded = alwaysShowInputField || this.state.focused || (this.state.value && this.state.value>0) ? true : false;
        
        const inputStyle = {
            color: (isValid==null&&this.state.focused==false)? changed ? "#ffffff" : "#78829c" : undefined,
            width: expanded ? "100%" : "42px",
            left: expanded ? "0px" : "calc(100% - 42px)",
        };
        const iconMinusStyle = {
            left: expanded ? "0px" : "calc(100% - 42px)",   
            marginTop: small ? "-5px" : "0px"         
        };
        const iconMinusClickStyle = {
            pointerEvents: expanded?undefined:"none",
        };
        const iconPlusStyle = {
            left: "calc(100% - 42px)",
            marginTop: small ? "-5px" : "0px" ,     
            backgroundColor: notActive ? "#f6f7f8" : "rgba(255,255,255,0)"
        };

        return (
            // #3dc184 - grön, #e63332 - röd
            <div className={className?className:"input-counterField-wrapper"} style={{backgroundColor:changed?"#e63332" : invisibleBackground?"rgba(255,255,255,0)":undefined,width: expanded || small ? "100%" : "42px"}}>
                {expanded ? (
                    <input
                        className={`input-counterField ${border?"":"no-border"} ${small?"small":""}`}
                        type="text"
                        onChange={this.onChange}
                        onKeyUp={this.onKeyUp}
                        disabled={disabled}
                        value={alwaysShowInputField? (this.state.value || "") :this.state.value || ""}
                        onFocus={this.onFocus}
                        onBlur={this.onBlur}
                        style={inputStyle}
                        spellCheck={spellcheck==null?false:spellcheck}
                        placeholder={placeholder}
                        tabIndex={tabIndex}
                        maxLength={maxLength}
                    />
                ) : (
                    <div className={`input-counterField ${border?"":"no-border"} ${small?"small":""}`} style={inputStyle} onClick={disabled?undefined:this.onClickAdd}></div>
                )}
                <div className={"icon noselect"} style={iconMinusStyle}>
                    <Icon type={notActive && !expanded ? iconTypes.warning : iconTypes.minus} color={changed ? iconColor.white : iconColor.red} opacity={disabled && !notActive?0.5:undefined}/>
                    <div className="input-decrease" onClick={disabled && !notActive?undefined:this.onClickDecrease} style={iconMinusClickStyle} />
                </div>
                <div className={"icon noselect"} style={iconPlusStyle} title={notActive ? notActiveText : ""}>
                    <Icon type={notActive ? iconTypes.warning : iconTypes.plus} color={changed ? iconColor.white :iconColor.red} opacity={disabled?0.5:undefined}/>
                    <div className="input-increase" onClick={disabled?undefined:this.onClickAdd}/>
                </div>
            </div>
        );
    }
}

CounterField.propTypes = {
    // Mandatory
    onEdit: PropTypes.func,  // onEdit(change)
    value: PropTypes.number,
    // Optional
    salesLineId: PropTypes.number,
    valueTotal: PropTypes.number,
    maxLength: PropTypes.number,
    disabled: PropTypes.bool,
    isValid: PropTypes.bool,
    spellcheck: PropTypes.bool,
    placeholder: PropTypes.string,
    tabIndex: PropTypes.number,
    usingSubmit: PropTypes.bool,
    className: PropTypes.string,
    border: PropTypes.bool,
    small: PropTypes.bool,
    invisibleBackground: PropTypes.bool,
    alwaysShowInputField: PropTypes.bool,
    minValue: PropTypes.number,
    product: PropTypes.object,
    activeOrder: PropTypes.object,
    notActive: PropTypes.bool,
    notActiveText: PropTypes.string,
    changed: PropTypes.bool,
};

CounterField.defaultProps = {
    disabled: false,
    isValid: null,
    usingIcon: undefined,
    usingSubmit: false,
    border: true,
    small: false,
    invisibleBackground: false,
    alwaysShowInputField: false,
    minValue: 0,
};